export const shiftOptions = ['Morning', 'Evening', 'Night', 'Full Day'];

export const permissionOptions = [
  { id: 'check-in', label: 'Member Check-in' },
  { id: 'billing', label: 'Billing & Payments' },
  { id: 'members', label: 'Manage Members' },
  { id: 'visitors', label: 'Visitor Registration' },
  { id: 'reports', label: 'View Reports' },
];
